const INITIAL_STATE = {
  list: [],
  listProductsOrders: [],
  loading: true,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'FINANCIAL_DASHBOARD_FETCHED':
      return {
        ...state,
        list: action.payload.data,
        loading: false,
      };
    case 'FINANCIAL_DASHBOARD_PRODUCTS_ORDERS_FETCHED':
      return {
        ...state,
        listProductsOrders: action.payload,
        loading: false,
      };
    case 'FINANCIAL_DASHBOARD_LOAD':
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};
